import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  radius,
  screen,
  shadow,
  spacing
} from 'theme';

export const StyledWrapper = styled.div`
  background-color: ${color('sand_100')};
`;

export const StyledContainer = styled.div`
  max-width: ${container('lg')};
  margin: auto;
  padding: ${spacing('xl5')} ${spacing('md')} ${spacing('xl4')};
  text-align: center;
`;

export const StyledHeader = styled.div`
  max-width: ${container('lg')};
  margin: auto;

  p {
    margin-top: ${spacing('lg')};
    margin-bottom: ${spacing('xl')};
  }
`;

export const StyledItems = styled.div`
  margin-top: ${spacing('xl3')};
  margin-bottom: ${spacing('xl3')};
  display: grid;
  gap: ${spacing('mdlg')};
  grid-template-columns: minmax(0, 1fr);

  @media (min-width: ${screen('md')}) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
`;

export const StyledItem = styled.div`
  background-color: ${color('white')};
  box-shadow: ${shadow('sm')};
  border-radius: ${radius('lg')};
  padding: ${spacing('mdlg')};
  display: flex;
  flex-direction: column;
  gap: ${spacing('lg')};

  h4 {
    font-size: ${fontSize('xl')};
    margin: 0;
    font-weight: ${fontWeight('extraBold')};

    &::before {
      content: '';
      display: block;
      margin: 0 auto ${spacing('md')};
      width: ${spacing('xl')};
      height: ${spacing('xs2')};
      background-color: ${color('cyan_500')};
    }
  }

  img {
    max-width: 11.25rem;
    margin: auto;
  }

  p {
    margin: 0;
  }
`;

export const StyledDesc = styled.p`
  font-size: ${fontSize('sm')};
  line-height: 1.428;
  display: flex;
  flex-direction: column;
  gap: ${spacing('xs')};

  span:first-of-type {
    font-size: ${fontSize('xs')};
    line-height: 1.333;
    text-transform: uppercase;
    letter-spacing: 0.25em;
    font-weight: ${fontWeight('extraBold')};
    color: ${color('text_subtle')};
  }
`;
